export const EMAIL_ARCHIVE = 'email_archive';
export const EMAIL_ARCHIVE_TEXT = 'Email Archive';
